interface BranchPreviewConfig {
  branchPreviewUrl?: string;
  branchPreviewName?: string;
}

export const getBranchPreviewConfig = (): BranchPreviewConfig => {
  let config = {};

  if (localStorage.getItem('odsBranchPreviewUrl') !== null) {
    config = {
      branchPreviewUrl: localStorage.getItem('odsBranchPreviewUrl')
    };
  }

  if (localStorage.getItem('odsBranchPreviewName') !== null) {
    config = {
      branchPreviewName: localStorage.getItem('odsBranchPreviewName')
    };
  }

  return config;
};

export const setBranchPreviewName = (name: string) => {
  localStorage.setItem('odsBranchPreviewName', name);
};

export const setBranchPreviewUrl = (name: string) => {
  localStorage.setItem('odsBranchPreviewUrl', name);
};

export const deleteBranchPreviewName = () => {
  localStorage.removeItem('odsBranchPreviewName');
};

export const deleteBranchPreviewUrl = () => {
  localStorage.removeItem('odsBranchPreviewUrl');
};
